import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { GLOBAL_CONFIG } from "@/global-config";

/**
 * merge classnames
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

/**
 * check if item exists in resourcePool
 */
export const check = (item: string, resourcePool: string[]) => {
	return resourcePool.some((p) => p === item);
};

/**
 * check if any item exists in resourcePool
 */
export const checkAny = (items: string[], resourcePool: string[]) => items.some((item) => check(item, resourcePool));

/**
 * check if all items exist in resourcePool
 */
export const checkAll = (items: string[], resourcePool: string[]) => items.every((item) => check(item, resourcePool));

/**
 * join url parts
 * @example
 * urlJoin('/admin/', '/api/', '/user/') // '/admin/api/user'
 * urlJoin('/admin', 'api', 'user/')     // '/admin/api/user'
 * urlJoin('/admin/', '', '/user/')      // '/admin/user'
 */
export const urlJoin = (...parts: string[]) => {
	const result = parts
		.map((part) => {
			return part.replace(/^\/+|\/+$/g, ""); // 去除两边/
		})
		.filter(Boolean);
	return `/${result.join("/")}`;
};

export const resolveImageUrl = (url: string | null | undefined) => {
	const value = `${url ?? ""}`.trim();
	if (!value) return "";
	if (/^(https?:)?\/\//i.test(value) || /^(data|blob):/i.test(value)) return value;
	if (value.startsWith("/src/") || value.startsWith("/assets/")) return value;

	const baseUrl = GLOBAL_CONFIG.imageBaseUrl.replace(/\/+$/g, "");
	if (!baseUrl) return value;
	return `${baseUrl}/${value.replace(/^\/+/g, "")}`;
};
